exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".questionnaire-answer .el-dialog__body{padding:0}.qu-textarea-input .el-textarea.is-disabled .el-textarea__inner{color:#000}", ""]);

// exports
